import Converter from "@/components/Converter";
import { useSearchParams } from "react-router-dom";

export default function Convert() {
  const [params] = useSearchParams();

  const from = params.get("from") ?? undefined;
  const to = params.get("to") ?? undefined;
  const amount = params.get("amount") ?? undefined;

  return (
    <div className="px-4 py-8 md:py-12">
      <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
        Currency &amp; Crypto Converter
      </h1>

      <p className="text-sm text-muted-gray mb-6">
        Check exchange rates and convert between supported currencies and
        digital assets.
      </p>

      <Converter initialFrom={from} initialTo={to} initialAmount={amount} />

      <div className="mt-10">{/* <PopularConversions /> */}</div>
    </div>
  );
}
